import { buildWebITData } from "./buildWebIT.data";

export const contactUsHeaderData = {
  title: "Let's build together",
  description:
    "Have a project in mind? We are ready to create your website or design that helps your business grow. Tell us what you need and we will handle the rest.",
  contactTitle: "Prefer a call?",
  contactNumber: buildWebITData.phone,
  emailTitle: "Drop us a line at",
  email: buildWebITData.email,
  infoEmail: buildWebITData.infoEmail,
};

export const contactData = [
  {
    type: "whatsapp",
    src: "/assets/social-icons/whatsapp.svg",
    href: `https://wa.me/${buildWebITData.phone}`,
    title: "Whatsapp",
    openInNewPage: true,
    width: 34,
    height: 34,
    serviceIconSize: {
      width: 28,
      height: 28,
    },
  },
  {
    type: "linkedin",
    src: "/assets/social-icons/linkedin.svg",
    href: "https://www.linkedin.com/company/buildwebit",
    title: "LinkedIn",
    openInNewPage: true,
    width: 34,
    height: 34,
    serviceIconSize: {
      width: 30,
      height: 30,
    },
  },
  {
    type: "facebook",
    src: "/assets/social-icons/facebook.svg",
    href: buildWebITData.facebookLink,
    title: "Facebook",
    openInNewPage: true,
    width: 42,
    height: 42,
    serviceIconSize: {
      width: 30,
      height: 30,
    },
  },
  {
    type: "email",
    src: "/assets/social-icons/gmail.webp",
    // href: `https://mail.google.com/mail/?view=cm&fs=1&to=buildweb.it@gmail.com&su=SUBJECT&body=BODY`,
    href: `mailto:${buildWebITData.email}`,
    title: "Email",
    openInNewPage: true,
    width: 28,
    height: 28,
    serviceIconSize: {
      width: 23,
      height: 23,
    },
  },
  {
    type: "booking",
    src: "/assets/social-icons/google-meet.svg",
    href: "/book-a-meeting",
    title: "Booking",
    openInNewPage: false,
    width: 28,
    height: 28,
    hideInService: true,
    serviceIconSize: {
      width: 30,
      height: 30,
    },
  },
];
